"use strict";
const HEALTH_TEXT = {
    red: 'Poor',
    yellow: 'Average',
    green: 'Good',
    cancel: 'Cancelled',
    free: 'Free',
    paying: 'Paying',
    default: 'Unknown',
};
const HEALTH_TEXT_SHORT = {
    yellow: 'Avg.',
};
const formatHealth = (healthRank, isShort) => {
    if (isShort && HEALTH_TEXT_SHORT[healthRank]) {
        return HEALTH_TEXT_SHORT[healthRank];
    }
    return HEALTH_TEXT[healthRank] || HEALTH_TEXT.default;
};
module.exports = formatHealth;
//# sourceMappingURL=formatHealth.js.map